import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "SupplierEnterpriseDashboardPage" */
	'pages/supplier/SupplierEnterprise/SupplierEnterpriseDashboardPage'));

export default [{ component, exact: true, path: '/supplier_enterprises/:supplierEnterpriseId' }];